/**
 * Created by andrey on 04.06.2024.
 */
import CleverAppsNative from "./cleverappsnative";
import Utils from "./utils";

const measurementId = "G-LT4LP0F0BN";

const debugMode = process.env.VUE_APP_MODE === "staging";
let gameParams = {};

const GoogleAnalytics = {
    logEvent: function (options) {
        let params = options.params || {};
        params = { ...params, ...gameParams };

        gtag("event", options.name, params);
    },

    logPurchase: function (options) {
        GoogleAnalytics.logEvent({
            name: "purchase",
            params: options.params
        });
    },

    logAdRevenue: function (options) {
        GoogleAnalytics.logEvent({
            name: "ad_revenue",
            params: {
                ...options.params,
                ad_source: "Google AdSense",
                slot_id: "2518779793"
            }
        });
    }
};

export default {
    install: function () {
        CleverAppsNative.addPlugin("GoogleAnalytics", GoogleAnalytics);

        Utils.loadSdk(`//googletagmanager.com/gtag/js?id=${measurementId}`);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            // eslint-disable-next-line prefer-rest-params
            dataLayer.push(arguments);
        };
        window.gtag_enable_tcf_support = true;

        gtag("consent", "default", {
            "ad_storage": "granted",
            "ad_user_data": "granted",
            "ad_personalization": "granted",
            "analytics_storage": "granted"
        });

        gtag("js", new Date());

        const params = {};
        if (debugMode) {
            params.debug_mode = true;
        }

        gtag("config", measurementId, params);
    },
    setGameParams: function (gameId, gameName) {
        gameParams = {
            game_id: gameId,
            game_name: gameName
        };

        if (debugMode) {
            console.log("Google analytics game params", gameParams);
        }
    }
};